var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Loading } from './Loading';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: #f3f3f3;\n  z-index: 1;\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n"], ["\n  background: #f3f3f3;\n  z-index: 1;\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n"])));
var AppLoading = function () {
    return (React.createElement(Container, null,
        React.createElement(Loading, null)));
};
export { AppLoading };
var templateObject_1;
//# sourceMappingURL=AppLoading.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/AppLoading.js
// module id = 451
// module chunks = 0